<template>
  <div v-if="isOpen" class="url-modal-overlay"
    @mousedown="handleOverlayMouseDown"
    @mouseup="handleOverlayMouseUp"
  >
    <div class="url-modal-content" @mousedown="handleContentMouseDown">
      <h3 class="url-modal-title">クラウド保存が完了しました</h3>
      
      <div class="url-modal-body">
        <p class="url-description">
          以下のユニークURLからいつでもブックマークにアクセスできます。<br>
          このURLは<strong>次回からブラウザに自動で記憶</strong>されます。
        </p>
        
        <div class="url-container">
          <div class="url-display">{{ uniqueUrl }}</div>
          <button class="copy-button" @click="copyToClipboard">
            {{ copyStatus === 'copied' ? 'コピー完了' : 'コピー' }}
          </button>
        </div>
        
        <div class="pin-reminder">
          <div class="reminder-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="8" x2="12" y2="12"></line>
              <line x1="12" y1="16" x2="12.01" y2="16"></line>
            </svg>
          </div>
          <div class="reminder-text">
            <strong>重要：</strong> データへのアクセスには設定したPINコードが必要です。<br>
            認証は30日間有効で、その後は再度PINコードの入力が必要になります。
          </div>
        </div>
      </div>
      
      <div class="url-modal-footer">
        <button class="url-close-button" @click="close">閉じる</button>
      </div>
    </div>
    <!-- ネイティブalert代替トースト -->
    <v-snackbar v-model="snack.show" :color="snack.color" :timeout="4000" location="bottom">
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'UniqueUrlModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    uniqueUrl: {
      type: String,
      required: true,
      default: ''
    }
  },
  data() {
    return {
      copyStatus: 'ready',  // 'ready' or 'copied'
      mouseDownOnOverlay: false, // 追加: 外側でmousedownされたか
      // ネイティブalert代替トースト
      snack: { show: false, text: '', color: 'error' }
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.copyStatus = 'ready';
      }
    }
  },
  methods: {
    showSnack(text, color = 'error') {
      this.snack.text = text;
      this.snack.color = color;
      this.snack.show = true;
    },

    copyToClipboard() {
      if (!this.uniqueUrl) return;
      
      try {
        // クリップボードにコピー！
        navigator.clipboard.writeText(this.uniqueUrl).then(() => {
          this.copyStatus = 'copied';
          
          // 2秒後に状態をリセット
          setTimeout(() => {
            this.copyStatus = 'ready';
          }, 2000);
        });
      } catch (error) {
        console.error('クリップボードへのコピーに失敗しました', error);
        this.showSnack('URLのコピーに失敗しました。手動でコピーしてください。');
      }
    },
    
    close() {
      this.$emit('close');
    },
    
    // オーバーレイのmousedown/mouseupハンドラ
    handleOverlayMouseDown(e) {
      if (e.target.classList.contains('url-modal-overlay')) {
        this.mouseDownOnOverlay = true;
      } else {
        this.mouseDownOnOverlay = false;
      }
    },
    handleOverlayMouseUp(e) {
      if (
        this.mouseDownOnOverlay &&
        e.target.classList.contains('url-modal-overlay')
      ) {
        this.close();
      }
      this.mouseDownOnOverlay = false;
    },
    
    // モーダル本体でmousedown時はフラグリセット
    handleContentMouseDown() {
      this.mouseDownOnOverlay = false;
    }
  }
}
</script>

<style scoped>
.url-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
}

.url-modal-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.url-modal-title {
  color: #333;
  margin-top: 0;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.url-description {
  margin-bottom: 20px;
  font-size: 0.95rem;
  line-height: 1.5;
  color: #555;
}

.url-container {
  display: flex;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 20px;
}

.url-display {
  flex: 1;
  padding: 10px;
  background-color: #f8f8f8;
  font-family: monospace;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.copy-button {
  background-color: #e9d0ca;
  border: none;
  color: #333;
  padding: 10px 15px;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
  font-weight: 500;
}

.copy-button:hover {
  background-color: #e0c0b8;
}

.pin-reminder {
  display: flex;
  background-color: #f8f8f8;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 20px;
}

.reminder-icon {
  color: #e9d0ca;
  margin-right: 10px;
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
}

.reminder-text {
  flex: 1;
  font-size: 0.85rem;
  line-height: 1.5;
  color: #555;
}

.url-modal-footer {
  display: flex;
  justify-content: flex-end;
}

.url-close-button {
  background-color: #e9d0ca;
  color: #333;
  border: none;
  padding: 10px 18px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
}

.url-close-button:hover {
  background-color: #e0c0b8;
}

@media (max-width: 600px) {
  .url-modal-content {
    width: 95%;
    padding: 15px;
  }
  
  .url-display {
    font-size: 0.9rem;
  }
  
  .copy-button {
    padding: 8px 12px;
    font-size: 0.9rem;
  }
  
  .url-close-button {
    padding: 8px 15px;
  }
}
</style>